<template>
  <form
    class="contact--form w-full pt-6 px-8 pb-8"
    @submit.prevent="handleSubmit"
  >
    <div>
      <div class="w-full">
        <woot-avatar-uploader
          :label="$t('CONTACT_FORM.FORM.AVATAR.LABEL')"
          :src="avatarUrl"
          :username-avatar="name"
          :delete-avatar="!!avatarUrl"
          class="settings-item"
          @change="handleImageUpload"
          @onAvatarDelete="handleAvatarDelete"
        />
      </div>
    </div>
    <div>
      <div class="w-full">
        <label :class="{ error: $v.name.$error }">
          {{ $t('CONTACT_FORM.FORM.NAME.LABEL') }}
          <span class="text-red-500">*</span>
          <div class="input-error-wrapper">
        <input
            v-model.trim="name"
            type="text"
            :placeholder="$t('CONTACT_FORM.FORM.NAME.PLACEHOLDER')"
           
            @input="validateLength('name', 50)"
              @keydown="restrictSpace('name', $event, 50)"
          />
          <span v-if="errors.name" class="message text-red-500">
            {{ errors.name }}
           </span>
          </div>
        </label>

        <label :class="{ error: $v.email.$error }">
          {{ $t('CONTACT_FORM.FORM.EMAIL_ADDRESS.LABEL') }}
          <span class="text-red-500">*</span>
          <input
            v-model.trim="email"
            type="text"
            :placeholder="$t('CONTACT_FORM.FORM.EMAIL_ADDRESS.PLACEHOLDER')"
            @input="$v.email.$touch"
          />
          <span v-if="$v.email.$error" class="message">
            {{ $t('CONTACT_FORM.FORM.EMAIL_ADDRESS.ERROR') }}
          </span>
        </label>
      </div>
    </div>
    <div class="w-full">
      <label :class="{ error: $v.description.$error }">
        {{ $t('CONTACT_FORM.FORM.BIO.LABEL') }}
        <textarea
          v-model.trim="description"
          type="text"
          :placeholder="$t('CONTACT_FORM.FORM.BIO.PLACEHOLDER')"
            @input="validateLength('description', 200)"
             @keydown="restrictSpace('description', $event, 200)"
        />
        <span v-if="errors.description" class="message text-red-500">
        {{ errors.description}}
      </span>
      </label>
    </div>
    <div>
      <div class="w-full">
        <label
          :class="{
            error: isPhoneNumberNotValid,
          }"
        >
          {{ $t('CONTACT_FORM.FORM.PHONE_NUMBER.LABEL') }}
          <woot-phone-input
            v-model="phoneNumber"
            :value="phoneNumber"
            :error="isPhoneNumberNotValid"
            :placeholder="$t('CONTACT_FORM.FORM.PHONE_NUMBER.PLACEHOLDER')"
            @input="onPhoneNumberInputChange"
            @blur="$v.phoneNumber.$touch"
            @setCode="setPhoneCode"
          />
          <span v-if="isPhoneNumberNotValid" class="message">
            {{ phoneNumberError }}
          </span>
        </label>
        <div
          v-if="isPhoneNumberNotValid || !phoneNumber"
          class="callout small warning text-sm dark:bg-yellow-200/20 dark:text-yellow-400"
        >
          {{ $t('CONTACT_FORM.FORM.PHONE_NUMBER.HELP') }}
        </div>
      </div>
    </div>
   <div>
    <woot-input
      v-model.trim="companyName"
      class="w-full"
      :label="$t('CONTACT_FORM.FORM.COMPANY_NAME.LABEL')"
      :placeholder="$t('CONTACT_FORM.FORM.COMPANY_NAME.PLACEHOLDER')"
        @input="validateLength('companyName', 50)"
    />
 
   </div>
    <div>
      <div class="w-full">
        <label>
          {{ $t('CONTACT_FORM.FORM.COUNTRY.LABEL') }}
        </label>
        <multiselect
          v-model="country"
          track-by="id"
          label="name"
          :placeholder="$t('CONTACT_FORM.FORM.COUNTRY.PLACEHOLDER')"
          selected-label
          :select-label="$t('CONTACT_FORM.FORM.COUNTRY.SELECT_PLACEHOLDER')"
          :deselect-label="$t('CONTACT_FORM.FORM.COUNTRY.REMOVE')"
          :custom-label="countryNameWithCode"
          :max-height="160"
          :options="countries"
          :allow-empty="true"
          :option-height="104"
        />
      </div>
    </div>
    <div>
      <div v-if="currentAccountId==19||currentAccountId==23" class="w-full">
        <label>
          {{ $t('CONTACT_FORM.FORM.INBOX.LABEL') }}
        </label>
        <multiselect
          v-model="inbox"
          track-by="id"
          label="name"
          :placeholder="$t('CONTACT_FORM.FORM.INBOX.PLACEHOLDER')"
          selected-label
          :select-label="$t('CONTACT_FORM.FORM.INBOX.SELECT_PLACEHOLDER')"
          :deselect-label="$t('CONTACT_FORM.FORM.INBOX.REMOVE')"
          :custom-label="LabelName"
          :max-height="160"
          :options="inboxes"
          :allow-empty="true"
          :option-height="104"
        />
      </div>
    </div>
    <woot-input
      v-model="city"
      class="w-full"
      :label="$t('CONTACT_FORM.FORM.CITY.LABEL')"
      :placeholder="$t('CONTACT_FORM.FORM.CITY.PLACEHOLDER')"
      @input="validateLength('city', 50)"
    />
   

    <div class="w-full">
      <label> Social Profiles </label>
      <div
        v-for="socialProfile in socialProfileKeys"
        :key="socialProfile.key"
        class="input-group"
      >
        <span class="input-group-label">{{ socialProfile.prefixURL }}</span>
        <input
          v-model="socialProfileUserNames[socialProfile.key]"
          class="input-group-field"
          type="text"
          placeholder="Enter your username"
        />
      </div>
    </div>

    <div class="w-full">
         <textarea
           v-model.trim="remark"
           class="w-full"
           type="text"
           :label="$t('CONTACT_FORM.FORM.REMARKS.LABEL')"
           :placeholder="$t('CONTACT_FORM.FORM.REMARKS.PLACEHOLDER')"
            @input="validateLength('remark', 200)"
             @keydown="restrictSpace('remark', $event, 200)"
     
         />
         <span v-if="errors.remark" class="message text-red-500">
           {{ errors.remark }}
         </span>
       </div>

    <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
      <div class="w-full">
        <woot-submit-button
          :loading="inProgress"
          class="button-color"
          :button-text="$t('CONTACT_FORM.FORM.SUBMIT')"
          :disabled="isSubmitDisabled"
        />
        <button class="button clear" @click.prevent="onCancel">
          {{ $t('CONTACT_FORM.FORM.CANCEL') }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import {
  DuplicateContactException,
  ExceptionWithMessage,
} from 'shared/helpers/CustomErrors';
import { required, email } from 'vuelidate/lib/validators';
import countries from 'shared/constants/countries.js';
import {
  getInternationalPhoneDigits,
  isPhoneNumberValid,
} from 'shared/helpers/Validators';
import parsePhoneNumber from 'libphonenumber-js';
import { mapGetters } from 'vuex';

export default {
  mixins: [alertMixin],
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
    inProgress: {
      type: Boolean,
      default: false,
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
    extraValue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      countries: countries,
      companyName: '',
      description: '',
      email: '',
      name: '',
      phoneNumber: '',
      activeDialCode: '',
      avatarFile: null,
      initialFormData: null,
      avatarUrl: '',
      country: {
       id: '',
       name: '',
      },
      inbox: {
       id: '',
       name: '',
      },
      city: '',
      errors: {
        name: '',
        email: '',
        companyName: '',
        city: '',
        remark: '',
        description: '',
        socialProfiles: {
          facebook: '',
          twitter: '',
          linkedin: '',
          github: '',
        },
      },
      socialProfileUserNames: {
        facebook: '',
        twitter: '',
        linkedin: '',
        github: '',
      },
      remark: '',
      socialProfileKeys: [
        { key: 'facebook', prefixURL: 'https://facebook.com/' },
        { key: 'twitter', prefixURL: 'https://twitter.com/' },
        { key: 'linkedin', prefixURL: 'https://linkedin.com/' },
        { key: 'github', prefixURL: 'https://github.com/' },
      ],
    };
  },
  validations: {
    name: {
      required,
    },
    description: {},
    email: {
      email,
    },
    companyName: {},
    phoneNumber: {},
    bio: {},
  },
  computed: {
    ...mapGetters({
      inboxes: 'inboxes/getInboxes',
      currentAccountId: 'getCurrentAccountId',
    }),
    parsePhoneNumber() {
      return parsePhoneNumber(this.phoneNumber);
    },
    isPhoneNumberNotValid() {
  if (!this.phoneNumber) return false;
  if (!this.activeDialCode) return true;

  const fullDigits = getInternationalPhoneDigits(
    this.activeDialCode,
    this.phoneNumber
  );

  if (fullDigits.length < 6 || fullDigits.length > 15) return true;

  return !isPhoneNumberValid(this.phoneNumber, this.activeDialCode);
},
phoneNumberError() {
  if (!this.activeDialCode) {
    return this.$t('CONTACT_FORM.FORM.PHONE_NUMBER.DIAL_CODE_ERROR');
  }
  const fullDigits = getInternationalPhoneDigits(
    this.activeDialCode,
    this.phoneNumber
  );

  if (fullDigits.length < 6 || fullDigits.length > 15) {
    return 'Phone number must be between 6 and 15 digits including country code';
  }
  if (!isPhoneNumberValid(this.phoneNumber, this.activeDialCode)) {
    return this.$t('CONTACT_FORM.FORM.PHONE_NUMBER.ERROR');
  }

  return '';
},
    setPhoneNumber() {
      if (!this.phoneNumber) {
        return null;
      }

      if (this.parsePhoneNumber && this.parsePhoneNumber.countryCallingCode) {
        return this.phoneNumber;
      }
      if (this.phoneNumber === '' && this.activeDialCode !== '') {
         return '';
         }
      return this.activeDialCode
        ? `${this.activeDialCode}${this.phoneNumber}`
        : null;
    },
    isSubmitDisabled() {
      return !this.isFormChanged() || !this.name || (!this.email && !this.phoneNumber) || this.$v.$invalid || this.isPhoneNumberNotValid;
    },
  },
  watch: {
    contact() {
      this.setContactObject();
    },
  },
  mounted() {
    this.setContactObject();
    this.setDialCode();
    this.captureInitialState();
  },
  methods: {
    validateLength(field, maxLength) {
      if (this[field].length > maxLength) {
        // Trim the input to the max length including spaces
        this[field] = this[field].slice(0, maxLength);
        this.$set(this.errors, field, `Maximum character should be ${maxLength}.`);
      } else {
        this.$set(this.errors, field, ''); // Clear the error when valid
      }
    },
validateSocialProfile(key) {
  const maxLength = 50;
  if (this.socialProfileUserNames[key].length > maxLength) {
    this.errors.socialProfiles[key] = `Max character is ${maxLength}.`;
  } else if (this.socialProfileUserNames[key].length === maxLength) {
    this.errors.socialProfiles[key] = `Maximum character should be ${maxLength}.`;
  } else {
    this.errors.socialProfiles[key] = ''; // Clear error
  }
},
restrictSpace(field, event, maxLength) {
      // Prevent space bar if character limit is reached
      if (event.key === ' ' && this[field].length >= maxLength) {
        event.preventDefault(); // Block space from being added
      }
    },
    onCancel() {
      this.$emit('cancel');
    },
    onSuccess() {
      this.$emit('success');
      bus.$emit('reload-contact-updated', true);
    },
    countryNameWithCode({ name, id }) {
      if (!id) return name;
      if (!name && !id) return '';
      return `${name} (${id})`;
    },
    LabelName({name}){
      return `${name}`;
    },
    setDialCode() {
    if (
      this.phoneNumber !== '' &&
      this.parsePhoneNumber &&
      this.parsePhoneNumber.countryCallingCode
    ) {
      const dialCode = this.parsePhoneNumber.countryCallingCode;
      this.activeDialCode = `+${dialCode}`;
    } else {
      this.activeDialCode = '';
    }
    },
    setContactObject() {
      const {
        email: emailAddress,
        phone_number: phoneNumber,
        name,
        remark,
      } = this.contact;
      const additionalAttributes = this.contact.additional_attributes || {};

      this.name = name || '';
      this.email = emailAddress || '';
      this.phoneNumber = phoneNumber || '';
      this.remark = additionalAttributes.remark || '';
      this.companyName = additionalAttributes.company_name || '';
      this.country = {
        id: additionalAttributes.country_code || '',
        name:
          additionalAttributes.country ||
          this.$t('CONTACT_FORM.FORM.COUNTRY.SELECT_COUNTRY'),
      };
      this.inbox = {
        id: additionalAttributes.inbox_id || '',
        name:
          additionalAttributes.inbox ||
          this.$t('CONTACT_FORM.FORM.INBOX.SELECT_INBOX'),
      };
      this.city = additionalAttributes.city || '';
      this.description = additionalAttributes.description || '';
      this.avatarUrl = this.contact.thumbnail || '';
      const {
        social_profiles: socialProfiles = {},
        screen_name: twitterScreenName,
      } = additionalAttributes;
      this.socialProfileUserNames = {
        twitter: socialProfiles.twitter || twitterScreenName || '',
        facebook: socialProfiles.facebook || '',
        linkedin: socialProfiles.linkedin || '',
        github: socialProfiles.github || '',
        instagram: socialProfiles.instagram || '',
      };
    },
    getContactObject() {
      if (this.country === null) {
        this.country = {
          id: '',
          name: '',
        };
      }
      const contactObject = {
        id: this.contact.id,
        name: this.name,
        email: this.email,
        phone_number: this.setPhoneNumber,
        remark: this.remark, 
        additional_attributes: {
          ...this.contact.additional_attributes,
          description: this.description,
          company_name: this.companyName,
          country_code: this.country.id,
          inbox_id: this.inbox.id,
          country:
            this.country.name ===
            this.$t('CONTACT_FORM.FORM.COUNTRY.SELECT_COUNTRY')
              ? ''
              : this.country.name,
              inbox:
            this.inbox.name ===
            this.$t('CONTACT_FORM.FORM.INBOX.SELECT_COUNTRY')
              ? ''
              : this.inbox.name,
          city: this.city,
          social_profiles: this.socialProfileUserNames,
          remark: this.remark,
        },
      };
      if (this.avatarFile) {
        contactObject.avatar = this.avatarFile;
        contactObject.isFormData = true;
      }
      return contactObject;
    },
    onPhoneNumberInputChange(value, code) {
      this.activeDialCode = code;
    },
    setPhoneCode(code) {
      if (this.phoneNumber !== '' && this.parsePhoneNumber) {
        const dialCode = this.parsePhoneNumber.countryCallingCode;
        if (dialCode === code) {
          return;
        }
        this.activeDialCode = `+${dialCode}`;
        const newPhoneNumber = this.phoneNumber.replace(
          `+${dialCode}`,
          `${code}`
        );
        this.phoneNumber = newPhoneNumber;
      } else {
        this.activeDialCode = code;
      }
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid || this.isPhoneNumberNotValid) {
        return;
      }
      try {
        const response = await this.onSubmit(this.getContactObject());
        this.onSuccess();
        this.showAlert(this.extraValue ? "Contact Already Exists" : this.$t('CONTACT_FORM.UPDATED_MESSAGE'));
      } catch (error) {
        if (error instanceof DuplicateContactException) {
          if (error.data.includes('email')) {
            this.showAlert(
              this.$t('CONTACT_FORM.FORM.EMAIL_ADDRESS.DUPLICATE')
            );
          } else if (error.data.includes('phone_number')) {
            this.showAlert(this.$t('CONTACT_FORM.FORM.PHONE_NUMBER.DUPLICATE'));
          }
        } else if (error instanceof ExceptionWithMessage) {
          this.showAlert(error.data);
        } else {
          this.showAlert(this.$t('CONTACT_FORM.ERROR_MESSAGE'));
        }
      }
      bus.$emit('dropdown-data-contact', true);
    },
    handleImageUpload({ file, url }) {
      this.avatarFile = file;
      this.avatarUrl = url;
    },
    async handleAvatarDelete() {
      try {
        if (this.contact && this.contact.id) {
          await this.$store.dispatch('contacts/deleteAvatar', this.contact.id);
          this.showAlert(
            this.$t('CONTACT_FORM.DELETE_AVATAR.API.SUCCESS_MESSAGE')
          );
        }
        this.avatarFile = null;
        this.avatarUrl = '';
        // this.activeDialCode = '';
        this.setDialCode();
      } catch (error) {
        this.showAlert(
          error.message
            ? error.message
            : this.$t('CONTACT_FORM.DELETE_AVATAR.API.ERROR_MESSAGE')
        );
      }
    },
    
    captureInitialState() {
      this.initialFormData = JSON.stringify(this.getContactObject());
    },
    isFormChanged() {
      const currentFormData = JSON.stringify(this.getContactObject());
      return currentFormData !== this.initialFormData;
    },
  },
};
</script>

<style scoped lang="scss">
.input-group-label {
  @apply text-sm bg-slate-50 dark:bg-slate-700 text-slate-800 dark:text-slate-100 border-slate-200 dark:border-slate-600;
}

:deep {
  .multiselect .multiselect__tags .multiselect__single {
    @apply pl-0;
  }
}

.settings-item :deep(label:last-of-type) {
  display: inline-flex;
  align-items: center;
  width: auto;
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  background-color: #fafafa;

  &:hover {
    background-color: #f3f4f6;
    border-color: #9ca3af;
  }
}

.settings-item :deep(input[type='file']) {
  width: auto;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 13px;
}

.message {
  font-size: 12px;
  margin-top: -13px;
}
.input-error-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2px; /* Adjust to reduce spacing, use 0 if needed */
}

</style>
